export default function Cards({tytul,opis}){

return(
<div className="col-md-4 mb-4">
      <div className="card shadow-sm h-100">
        <div className="card-body">
          <h5 className="card-title">{tytul}</h5>
          <p className="card-text">{opis}</p>
        </div>
      </div>
    </div>
)

}